import React from "react";

import { Styles } from "./styles/contact.js";

const GoogleMap = () => {
  return (
    <Styles>
      <div className="google-map-area">
        <iframe
          src="https:////www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3002.970069838473!2d69.19644337643155!3d41.17882000890573!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38aef5cb9b8f802f%3A0x961a61766a06c5f8!2sPharmaceutical%20Technical%20University!5e0!3m2!1sen!2s!4v1729247924346!5m2!1sen!2s"
          width="100%"
          height="600"
          style={{ border: 0 }}
          allowFullScreen={true}
          loading="lazy"
        />
      </div>
    </Styles>
  );
};

export default GoogleMap;
